import {Tournament} from '../types'


export const GetFormattedDate= (d:Date) => {
    const date = new Date(d);
    const formatedDate = `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`;
    return formatedDate;
}

export const GetTournamentProgress = (tournament:Tournament) =>{
    if(tournament === null || tournament.GroupStageGames == null){
        return {}
    }
    let games = 0;
    let gamesCompleted = 0;
    tournament.GroupStageGames.forEach((g) => {
        if(g.Winners.length > 0){
            gamesCompleted++;
        }
        games++;
    })
    return {
        games,
        gamesCompleted
    }
}


